export default __webpack_public_path__ + "static/media/League.0a702fc4.png";